import './FormGrid.scss'
import type { ComponentProps } from 'react'
import { clx } from '../clx'
import { LabelPlacementContext } from '../Field'

export interface FormGridProps extends ComponentProps<'div'> {
  /** Column count from `tablet` up. One column below tablet, always. */
  columns?: 1 | 2
  /**
   * `inline` puts every Field's label beside its control, in one column
   * shared by the whole grid (ADR 0020). Stacked below `tablet`.
   */
  labelPlacement?: 'top' | 'inline'
}

/** Form layout: one column on mobile, two from tablet up (SPEC §5.4). */
export function FormGrid({
  columns = 2,
  labelPlacement = 'top',
  className,
  children,
  ...rest
}: FormGridProps) {
  return (
    <div
      {...rest}
      className={clx(
        'form-grid',
        columns === 1 && 'form-grid--is-single',
        labelPlacement === 'inline' && 'form-grid--is-inline',
        className
      )}
    >
      <LabelPlacementContext value={labelPlacement}>{children}</LabelPlacementContext>
    </div>
  )
}

/** A FormGrid child that spans every column. */
export function FormGridFull({ className, ...rest }: ComponentProps<'div'>) {
  return <div {...rest} className={clx('form-grid__full', className)} />
}
